import { DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS } from '../constants/legalConsent';
import LegalConsentKeys from '../constants/legalConsentKeys';
import ProcessingConsentTypes from '../constants/processingConsentTypes';
import LegalConsentOptions from '../constants/legalConsentOptions';
const LegalConsentKeyBuilders = [{
  key: LegalConsentKeys.IS_LEGITIMATE_INTEREST,
  getValue: ({
    legalConsentOption
  }) => legalConsentOption === LegalConsentOptions.LEGITIMATE_INTEREST
}, {
  key: LegalConsentKeys.COMMUNICATION_CONSENT_TEXT,
  getValue: ({
    legalConsentCopy
  }) => legalConsentCopy.consentToCommunicate
}, {
  key: LegalConsentKeys.COMMUNICATION_CONSENT_CHECKBOXES,
  getValue: ({
    communicationConsentCheckboxes
  }) => communicationConsentCheckboxes
}, {
  key: LegalConsentKeys.PROCESSING_CONSENT_TYPE,
  getValue: ({
    legalConsentOption
  }) => legalConsentOption === LegalConsentOptions.SEPERATE_CONSENT ? ProcessingConsentTypes.REQUIRED_CHECKBOX : ProcessingConsentTypes.IMPLICIT
}, {
  key: LegalConsentKeys.PROCESSING_CONSENT_TEXT,
  getValue: ({
    legalConsentCopy,
    isImplicityConsent
  }) => {
    return isImplicityConsent ? legalConsentCopy.consentToProcessDataImplicit : legalConsentCopy.consentToProcessDataExplicit;
  }
}, {
  key: LegalConsentKeys.PROCESSING_CONSENT_CHECKBOX_LABEL,
  getValue: ({
    legalConsentCopy
  }) => legalConsentCopy.consentToProcessDataCheckbox
}, {
  key: LegalConsentKeys.PRIVACY_POLICY_TEXT,
  getValue: ({
    legalConsentCopy,
    isLegitimateInterest
  }) => isLegitimateInterest ? legalConsentCopy.legitimateInterest : legalConsentCopy.privacyPolicy
}, {
  key: LegalConsentKeys.SUBSCRIPTION_TYPES,
  getValue: ({
    communicationConsentCheckboxes,
    isLegitimateInterest
  }) => {
    return isLegitimateInterest && communicationConsentCheckboxes[0] ? [communicationConsentCheckboxes[0].communicationTypeId] : [];
  }
}, {
  key: LegalConsentKeys.LAWFUL_BASIS,
  getValue: () => DEFAULT_LEGITIMATE_INTEREST_LEGAL_BASIS
}];
export default LegalConsentKeyBuilders;